import { useProductData } from './useProductData';
import { useProductFilters } from './useProductFilters';
import { useProductUI } from './useProductUI';
import { PaginatedCards } from '@/src/types/card';

interface UseProductListingProps {
    categoryFromUrl?: string;
    countryFromUrl?: string;
    initialCountries: string[];
    initialCategories: string[];
    initialProducts: PaginatedCards
}

export const useProductListing = (props: UseProductListingProps) => {
    // Filter state and logic
    const filters = useProductFilters(props);
    
    // Data fetching with ZERO useEffect hooks
    const data = useProductData({initialCountries: props.initialCountries, initialCategories: props.initialCategories, initialProducts: props.initialProducts});
    
    

    // UI state and interactions
    const ui = useProductUI({
        selectedCategory: filters.selectedCategory,
        selectedCountry: filters.selectedCountry,
        showDiscount: filters.showDiscount,
        showInStock: filters.showInStock,
        searchQuery: filters.searchQuery,
        categories: data.categories,
        countries: data.countries,
        totalCards: data.totalCards,
        cardsPerPage: filters.cardsPerPage,
        page: filters.page,
        setPage: filters.setPage,
        setSelectedCategory: filters.setSelectedCategory,
        setSelectedCountry: filters.setSelectedCountry,
        setShowDiscount: filters.setShowDiscount,
        setShowInStock: filters.setShowInStock,
        setSearchQuery: filters.setSearchQuery,
        updateURL: filters.updateURL,
        fetchCards: data.fetchCards,
        filterParams: filters.filterParams
    });

    return {
        // Data
        loading: data.loading,
        cards: data.cards,
        totalCards: data.totalCards,
        categories: data.categories,
        countries: data.countries,
        
        // Filter state
        page: filters.page,
        selectedCategory: filters.selectedCategory,
        selectedCountry: filters.selectedCountry,
        showDiscount: filters.showDiscount,
        showInStock: filters.showInStock,
        searchQuery: filters.searchQuery,
        cardsPerPage: filters.cardsPerPage,
        isMobile: filters.isMobile,
        
        // UI state
        mobileDrawerOpen: ui.mobileDrawerOpen,
        categoriesExpanded: ui.categoriesExpanded,
        countriesExpanded: ui.countriesExpanded,
        categorySearchFilter: ui.categorySearchFilter,
        countrySearchFilter: ui.countrySearchFilter,
        totalPages: ui.totalPages,
        breadcrumbs: ui.breadcrumbs,
        hasActiveFilters: ui.hasActiveFilters,
        filteredCategories: ui.filteredCategories,
        filteredCountries: ui.filteredCountries,
        
        // Direct control functions - NO useEffect
        
        // Handlers
        handlePageChange: ui.handlePageChange,
        handleMobileDrawerToggle: ui.handleMobileDrawerToggle,
        handleCategoryClick: ui.handleCategoryClick,
        handleCountryClick: ui.handleCountryClick,
        handleDiscountToggle: ui.handleDiscountToggle,
        handleInStockToggle: ui.handleInStockToggle,
        handleCardClick: ui.handleCardClick,
        handleClearCategory: ui.handleClearCategory,
        handleClearCountry: ui.handleClearCountry,
        handleClearDiscount: ui.handleClearDiscount,
        handleClearInStock: ui.handleClearInStock,
        handleClearSearch: ui.handleClearSearch,
        handleClearAllFilters: ui.handleClearAllFilters,
        getActiveFilters: ui.getActiveFilters,
        getPageTitle: ui.getPageTitle,
        handleItemsPerPageChange: filters.createHandleItemsPerPageChange(data.fetchCards),
        
        // Constants
        ITEMS_PER_PAGE_OPTIONS: filters.ITEMS_PER_PAGE_OPTIONS,
        
        // Setters
        setCategoriesExpanded: ui.setCategoriesExpanded,
        setCountriesExpanded: ui.setCountriesExpanded,
        setCategorySearchFilter: ui.setCategorySearchFilter,
        setCountrySearchFilter: ui.setCountrySearchFilter
    };
};
